var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAltImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4444 1H3.55556C2.14416 1 1 2.14416 1 3.55556V21.4444C1 22.8558 2.14416 24 3.55556 24H21.4444C22.8558 24 24 22.8558 24 21.4444V3.55556C24 2.14416 22.8558 1 21.4444 1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66688 11.2224C10.0783 11.2224 11.2224 10.0783 11.2224 8.66688C11.2224 7.25549 10.0783 6.11133 8.66688 6.11133C7.25549 6.11133 6.11133 7.25549 6.11133 8.66688C6.11133 10.0783 7.25549 11.2224 8.66688 11.2224Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 16.3331L20.0565 12.3898C19.5772 11.9107 18.9273 11.6416 18.2497 11.6416C17.572 11.6416 16.9221 11.9107 16.4429 12.3898L4.83301 23.9997",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltImage);
export default __webpack_public_path__ + "static/media/alt_image.55710b92e1a49b997f947671a35ddcd7.svg";
export { ForwardRef as ReactComponent };